import httpService from '../Api/http.service';
import { processPlanByFrequency } from 'Shared/Utils';
import { getApiBaseUrl } from 'utils';
const planServices = {
  createPlan: (data) =>
    httpService({
      url: `/plan`,
      method: 'post',
      data,
    }),

  updatePlan: (data, plan_package_id) =>
    httpService({
      url: `/plan/${plan_package_id}`,
      method: 'put',
      data,
    }),

  // fetchGroupPlans: (group_id) =>
  //   httpService(`/group_plans/${group_id}`),

  // fetchLocationPlans: (location_id) =>
  //   httpService(`/location_plan/${location_id}`),

  getPlanAttributes: () => httpService('/plans/supported-attributes'),

  getPlanDetails: (plan_id, group_id) =>
    httpService(`/plan/${plan_id}?group_id=${group_id}`),

  fetchGroupPlanPackages: (group_id, { all } = {}) =>
    httpService(`/group/${group_id}/plan-packages?mode=1${all ? '&all=yes' : ''}`),

  fetchLocationPlanPackages: (
    location_id,
    hiddenPlans = false,
    member_type = 'Customer',
    mode = 1,
    subscription_id = null,
  ) => {
    const queryParams = [`member_type=${member_type}`, `mode=${mode}`];
    
    if (hiddenPlans) {
      queryParams.push('all=yes');
    }
    
    if (subscription_id) {
      queryParams.push(`subscription_id=${subscription_id}`);
    }
    
    const queryString = queryParams.join('&');
    
    return httpService(`/location/${location_id}/plan-packages?${queryString}`).then((response) => ({
      ...response,
      data: {
        ...response.data,
        plansById: response?.data?.rows || [],
        plansByFrequency: processPlanByFrequency(response?.data?.rows || []),
      },
    }));
  },

  fetchLocationEmployeePlanPackages: (location_id, hiddenPlans = false) =>
    httpService(
      `/location/${location_id}/plan-packages?member_type=Employee${
        hiddenPlans ? '&all=yes' : ''
      }&mode=1`,
    ).then((response) => ({
      ...response,
      data: {
        ...response.data,
        plansById: response?.data?.rows || [],
        plansByFrequency: processPlanByFrequency(response?.data?.rows || []),
      },
    })),

  getPlanPackageDetails: (plan_package_id) =>
    httpService(`/plan-package/${plan_package_id}`),

  fetchCptTemplateCodes: () =>
    httpService({
      url: `${getApiBaseUrl()}/plans/templates/`,
      method: 'get',
    }),

  processCustomCodeTemplate: (formData) =>
    httpService({
      url: `${getApiBaseUrl()}/loop/plans/custom-codes/process-template`,
      method: 'post',
      data: formData,
    }),

  getDisplaySummary: (level, levelId) =>
    httpService({
      url: `${getApiBaseUrl()
      }/loop/plans/display-summary?level=${encodeURIComponent(level)
      }&level_id=${encodeURIComponent(levelId)}`,
      method: 'get',
      headers: {
        Accept:
          'application/vnd.ms-excel.sheet.macroEnabled.12, application/octet-stream, application/ms-excel',
      },
      responseType: 'arraybuffer',
    }),

  postDisplaySummary: (level, levelId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    return httpService({
      url: `${getApiBaseUrl()
      }/loop/plans/display-summary?level=${encodeURIComponent(level)
      }&level_id=${encodeURIComponent(levelId)}`,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default planServices;
